var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RealtimeSystem',{key:_vm.renderCount,attrs:{"componentKey":_vm.componentKey,"onAnyEventsSocketScheme":_vm.onAnyEventsSocketScheme},on:{"failedConnect":_vm.failedConnect,"endMatch":_vm.endMatch,"endDownload":_vm.endDownload}})}
var staticRenderFns = []

export { render, staticRenderFns }